export default __webpack_public_path__ + "f73c58ecf7aab337b9e6be845ffe32a4.svg";